import { Button, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SubscriptionAuthorActions.css';
import { ISubscriptionAuthorActionsProps } from './types';
import { CallSourceWishContainer } from '../../../containers/CallSourceWish';
import { CalltrackingBadgeContainer } from '../../../containers/CalltrackingBadge';

export const SubscriptionAuthorActions = (props: ISubscriptionAuthorActionsProps) => {
  const {
    isPhonesVisible,
    phones,
    isMessageButtonVisible,
    messageButtonText,
    handleShowPhonesClick,
    handleSendMessageClick,
  } = props;

  return (
    <div className={styles['buttons_wrapper']}>
      <div className={styles['buttons']}>
        {isPhonesVisible && <UIHeading4>{phones.join(', ')}</UIHeading4>}

        {!isPhonesVisible && (
          <Button theme="fill_primary" size="XS" onClick={handleShowPhonesClick}>
            Показать телефон
          </Button>
        )}

        {isMessageButtonVisible && (
          <div className={styles['button_send_message']}>
            <Button theme="fill_secondary" size="XS" onClick={handleSendMessageClick}>
              {messageButtonText}
            </Button>
          </div>
        )}
      </div>

      {isPhonesVisible && (
        <div className={styles['phones_hint']}>
          <CalltrackingBadgeContainer />
          <CallSourceWishContainer />
        </div>
      )}
    </div>
  );
};
